import { currentDevice } from '../../core/utils/currentDevice.js'
import { openLoader } from '../../elements/wait_loading/wait_loading.js'
import { createBottomSheet } from '../../shared/bottom_sheet/bottom_sheet.js'
import { copyToClipboardNew } from '../../utils/copy_to_clipboard.js'
import on from '../../utils/events_delegation.js'

let galleryInitialized = false

const initIbGallery = function () {
  if (!galleryInitialized) {
    galleryInitialized = true
    import(
      /* webpackChunkName: 'ib_gallery' */
      `./ib_gallery`
    )
  }
}

function init() {
  on({
    eventName: 'click',
    selector: '[data-multi-modal-trigger]',
    handler(e) {
      e.preventDefault()
      const elem = e.target.closest('[data-multi-modal-trigger]')
      initIbGallery()
      openLoader()

      import(
        /* webpackChunkName: 'multi_modal' */
        `../multi_modal/multi_modal.js`
      )
        .then(blockJS => blockJS.openMultiModal($(elem)))
        .catch(() => {})
    },
    once: true,
  })

  // TODO: Este click no debería estar aquí. Solo sirve para abrir el modal desde el badge de star prestige. Este fichero no debería ser el responsable de hacer esto.
  on({
    eventName: 'click',
    selector: '.is-star-prestige',
    handler(e) {
      e.preventDefault()
      const elem = e.target
      initIbGallery()
      import(
        /* webpackChunkName: 'star_prestige' */
        `../../shared/star_prestige/star_prestige`
      )
        .then(blockJS => blockJS.openStarPrestige($(elem)))
        .catch(() => {})
    },
    once: true,
  })

  // If isHotel -> render hotel_gallery
  if (IB.currentPageType.isHotel()) {
    on({
      eventName: 'click',
      selector: '.js-rrss-share-sheet .js-copy-to-clipboard',
      handler: () => {
        const url = window.location
        copyToClipboardNew(url)
      },
    })

    // --------------------------------------------------
    // SHARE RRSS BOTTOM SHEET
    // --------------------------------------------------
    if (currentDevice.isMobile) {
      let rrssShareBottomSheet
      on({
        eventName: 'click',
        selector: '.js-show-gallery-rrss-sheet',
        handler: event => {
          if (rrssShareBottomSheet) return
          rrssShareBottomSheet = createBottomSheet({
            showButton: event.target,
          })
          rrssShareBottomSheet.show()
        },
      })
    }
  }
}

init()
